import { getDealAndObjectType } from './getDealAndObjectType';

export const getAnalyticsCategory = (category: string | null | undefined) => {
  const { dealType, objectType } = getDealAndObjectType(category);

  return [dealType, objectType].filter(Boolean).join('/') || undefined;
};
